import References from '../../helpers/Reference';

export const AUTH_SETTINGS_KEY = 'user_settings';

const storageKey = (userId) => userId ? `${AUTH_SETTINGS_KEY}_${userId}` : AUTH_SETTINGS_KEY;

export const defaultUserSettings = {
    setting_holder_filter: 0,
    setting_holder_filter_areas: [],
    setting_wind_unit: 'rumbs',
    setting_pressure_unit: 'gPa'
};

const isServerSetting = (key) => !!(References.settingsCatalog && References.settingsCatalog[key] && References.settingsCatalog[key].serverSave);

const stripServerSettings = (settings) => {
    if (!settings || typeof settings !== 'object') {
        return {};
    }

    return Object.keys(settings).reduce((acc, key) => {
        if (!isServerSetting(key)) {
            acc[key] = settings[key];
        }
        return acc;
    }, {});
};

const mergeWithDefaults = (settings) => {
    const safeSettings = settings && typeof settings === 'object' ? stripServerSettings(settings) : {};
    const holderAreas = Array.isArray(safeSettings?.setting_holder_filter_areas)
        ? safeSettings.setting_holder_filter_areas
        : [];

    return {
        ...defaultUserSettings,
        ...safeSettings,
        setting_holder_filter: Number(safeSettings?.setting_holder_filter ?? defaultUserSettings.setting_holder_filter) ? 1 : 0,
        setting_holder_filter_areas: holderAreas,
        setting_wind_unit: safeSettings?.setting_wind_unit || defaultUserSettings.setting_wind_unit,
        setting_pressure_unit: safeSettings?.setting_pressure_unit || defaultUserSettings.setting_pressure_unit,
    };
};

export function loadUserSettings(userId) {
    if (typeof window === 'undefined') {
        return defaultUserSettings;
    }

    try {
        const rawSettings = localStorage.getItem(storageKey(userId));
        if (!rawSettings) {
            return defaultUserSettings;
        }

        const parsedSettings = JSON.parse(rawSettings);
        if (!parsedSettings || typeof parsedSettings !== 'object') {
            return defaultUserSettings;
        }

        return mergeWithDefaults(parsedSettings);
    } catch (error) {
        console.warn('Не удалось прочитать пользовательские настройки:', error);
        return defaultUserSettings;
    }
}

export function saveUserSettings(settings, userId) {
    if (typeof window === 'undefined') {
        return;
    }

    const safeSettings = mergeWithDefaults(settings);
    const localOnlySettings = stripServerSettings(safeSettings);

    try {
        localStorage.setItem(storageKey(userId), JSON.stringify(localOnlySettings));
    } catch (error) {
        console.warn('Не удалось сохранить пользовательские настройки:', error);
    }
}

export function resetUserSettings(userId) {
    if (typeof window === 'undefined') {
        return defaultUserSettings;
    }

    localStorage.removeItem(storageKey(userId));
    return defaultUserSettings;
}
